module.exports = __webpack_public_path__ + "img/idea_banner.d519dfb0.png";